import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as LocationServices from "../../../../services/LocationService";
import { useTranslation } from "react-i18next";
import LocationForm from "./locationForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";
import * as ViveroService from "../../../../services/ViveroService";

const LocationFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [viveros, setViveros] = useState([]);

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      name: data.name,
      active: data.active,
      viveroUuid: data.viveroUuid,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    const resultItems = await ViveroService.getAllViveros({
      filters: { active: true },
    });
    if (resultItems && resultItems.length > 0) {
      const dataViveros = resultItems.map((item) => {
        return {
          code: item.uuid,
          label: item.name,
        };
      });
      setViveros(dataViveros);
    }
    if (uuid) {
      const result = await LocationServices.getLocation(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await LocationServices.updateLocation(values, uuid);
        } else {
          result = await LocationServices.addLocation(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.location.messages.update.title");
            text = t("forms.location.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.location.messages.create.title");
            text = t("forms.location.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.location.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.LOCATION_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.LOCATION_LIST);
  };

  return (
    <LocationForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
      viveros={viveros}
    />
  );
};

LocationFormContainer.propTypes = {
  t: PropTypes.any,
};

export default LocationFormContainer;
